export default __webpack_public_path__ + "static/media/bubble_nova_background_l1.63cbd030.jpg";